export enum FeedbackMode {
    CANCEL,
    LIKE,
    DISLIKE
}

export type FeedbackResponse = { feedbackMode: FeedbackMode; identifier: string | number };
